import React from 'react';
import { Card } from '@/components/ui/card';
import { Bed } from '@phosphor-icons/react';

export default function IPDPage() {
  const beds = [
    { id: 1, ward: 'General Ward A', bedNo: '101', patient: 'John Smith', status: 'Occupied' },
    { id: 2, ward: 'General Ward A', bedNo: '102', patient: null, status: 'Available' },
    { id: 3, ward: 'ICU', bedNo: '201', patient: 'Emma Johnson', status: 'Occupied' },
    { id: 4, ward: 'ICU', bedNo: '202', patient: null, status: 'Available' },
  ];

  return (
    <div className="space-y-6" data-testid="ipd-page">
      <div>
        <h1 className="text-4xl md:text-5xl font-light tracking-tighter mb-2">IPD / Ward Management</h1>
        <p className="text-sm md:text-base leading-relaxed text-muted-foreground">
          Manage in-patient departments and bed allocation
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {beds.map((bed) => (
          <Card key={bed.id} className="p-4 hover-lift" data-testid={`bed-card-${bed.id}`}>
            <div className="flex items-start justify-between mb-3">
              <div>
                <p className="text-xs text-muted-foreground">{bed.ward}</p>
                <p className="text-lg font-medium">Bed {bed.bedNo}</p>
              </div>
              <Bed className="h-5 w-5 text-muted-foreground" weight="duotone" />
            </div>
            <div className="space-y-1">
              <p className="text-sm">
                {bed.patient ? bed.patient : 'Available'}
              </p>
              <div className={`inline-block px-2 py-0.5 rounded-full text-xs ${
                bed.status === 'Occupied' ? 'bg-destructive/10 text-destructive' : 'bg-success/10 text-success'
              }`}>
                {bed.status}
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}